import React, { useEffect, useRef } from "react";

const COLORS = ["#38bdf8", "#7cc7ff", "#e6c25a", "#a78bfa", "#34d399", "#ffffff"];

// Lightweight cursor sparkle trail (no deps). Spawns short-lived star particles
// that follow the pointer, then float up and fade. Disabled for reduced-motion / touch.
const CursorSparkle = () => {
  const layer = useRef(null);
  const last = useRef(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const el = layer.current;
    if (!el) return;

    const spawn = (x, y, big = false) => {
      const s = document.createElement("span");
      s.className = "ws-spark";
      const size = (big ? 10 : 5) + Math.random() * (big ? 8 : 6);
      const dx = (Math.random() - 0.5) * 40;
      const dy = -(18 + Math.random() * 42);
      const rot = (Math.random() * 220 - 110).toFixed(0);
      s.style.left = `${x}px`;
      s.style.top = `${y}px`;
      s.style.width = `${size}px`;
      s.style.height = `${size}px`;
      s.style.background = COLORS[(Math.random() * COLORS.length) | 0];
      s.style.setProperty("--dx", `${dx}px`);
      s.style.setProperty("--dy", `${dy}px`);
      s.style.setProperty("--rot", `${rot}deg`);
      s.style.animationDuration = `${700 + Math.random() * 500}ms`;
      el.appendChild(s);
      s.addEventListener("animationend", () => s.remove());
    };

    const onMove = (e) => {
      const now = performance.now();
      if (now - last.current < 32) return; // throttle ~30fps
      last.current = now;
      spawn(e.clientX, e.clientY, false);
      if (Math.random() > 0.72) spawn(e.clientX, e.clientY, true);
    };
    const onClick = (e) => { for (let i = 0; i < 8; i++) spawn(e.clientX, e.clientY, i % 2 === 0); };

    window.addEventListener("pointermove", onMove, { passive: true });
    window.addEventListener("pointerdown", onClick, { passive: true });
    return () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerdown", onClick);
    };
  }, []);

  return <div ref={layer} className="ws-spark-layer" aria-hidden />;
};

export default CursorSparkle;
